import { FormControlLabel, Checkbox, Tooltip, Typography } from '@mui/material'

interface Employee {
  id: string
  firstName: string
  lastName: string
}

interface EmployeeCheckboxListProps {
  employees: Employee[]
  selectedMentees: string[]
  handleMenteeChange: (event: React.ChangeEvent<HTMLInputElement>) => void
  isDownSm: boolean
}

const EmployeeCheckboxList: React.FC<EmployeeCheckboxListProps> = ({
  employees,
  selectedMentees,
  handleMenteeChange,
  isDownSm,
}) => {
  return (
    <>
      {employees?.map(l => {
        const labelComponent = (
          <FormControlLabel
            key={l.id}
            control={<Checkbox value={l.id} onChange={handleMenteeChange} checked={selectedMentees.includes(l.id)} />}
            label={
              <Typography
                sx={{
                  overflow: 'hidden',
                  whiteSpace: 'nowrap',
                  textOverflow: 'ellipsis',
                }}
              >
                {`${l.firstName} ${l.lastName}`}
              </Typography>
            }
          />
        )

        return isDownSm ? (
          <Tooltip title={`${l.firstName} ${l.lastName}`} placement="top" key={`${l.id}-filtering-menu-item-tooltip`}>
            {labelComponent}
          </Tooltip>
        ) : (
          labelComponent
        )
      })}
    </>
  )
}

export default EmployeeCheckboxList